import { render, staticRenderFns } from "./BalanceIssueAutoForm.vue?vue&type=template&id=b0e2c9a6&scoped=true"
import script from "./BalanceIssueAutoForm.vue?vue&type=script&lang=js"
export * from "./BalanceIssueAutoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e2c9a6",
  null
  
)

export default component.exports